import ProposeDetail from "./proposeDetail";

const DetailProcedureStep = (props: any) => {
    const taskId = props.taskId;
    const handleClose = props.handleClose;

    return <ProposeDetail taskId={taskId} handleClose={handleClose} />;
}

export default DetailProcedureStep;